/**
 * Unions API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PhotoDataLoyalty } from './photoDataLoyalty';
import { LoyaltyProductGroupBody } from './loyaltyProductGroupBody';
import { CityWithRegionViewDto } from './cityWithRegionViewDto';
import { ContactLoyalty } from './contactLoyalty';
import { MapObjectViewDto } from './mapObjectViewDto';


/**
 * Добавить продукт программы лояльности с массивом категорий и регионов – товар / услуга
 */
export interface LoyaltyProductWCategiriesAdd { 
    /**
     * Наименование продукта лояльности.
     */
    name: string;
    /**
     * Описание продукта лояльности.
     */
    description: string;
    /**
     * Краткое описание продукта лояльности.
     */
    descriptionShort?: string;
    /**
     * ID организации продукта.
     */
    organisationId?: string;
    /**
     * ID ассоциации.
     */
    parentOrganisationId?: string;
    /**
     * Информация о компании.
     */
    organisationInfo?: string;
    /**
     * Список контактов по продукту.
     */
    contacts?: Array<ContactLoyalty>;
    /**
     * Список фотографий продукта.
     */
    photos?: Array<PhotoDataLoyalty>;
    /**
     * Дата окончания размещения.
     */
    dateExpiration?: string;
    /**
     * Список ID категорий.
     */
    categoryIds: Array<string>;
    /**
     * Список ID регионов.
     * @deprecated
     */
    regionIds?: Array<string>;
    cities?: Array<CityWithRegionViewDto>;
    /**
     * Список групп получателей скидки.
     */
    discountGroups?: Array<LoyaltyProductGroupBody>;
    /**
     * ответственный сотрудник из объединения
     */
    contactUserId?: string;
    externalAuthorId?: string;
    externalOrganisationId?: string;
    externalOrganisationName?: string;
    externalOrganisationLogoId?: string;
    paidDuration?: number;
    paidBoostRateId?: string;
    paidNewsletterTier1Count?: number;
    paidNewsletterTier2Count?: number;
    paidNewsletterTier3Count?: number;
    requestLeadContacts?: boolean;
    eridToken?: string;
    eridAdInfo?: string;
    /**
     * текст скидки.
     */
    discountText?: string;
    /**
     * Сортировка.
     */
    sortOrder?: number;
    /**
     * Адреса с координатами
     */
    mapObjects?: Array<MapObjectViewDto>;
}

